<template>
  <v-content>
    <div class="staticHero">
      <v-img src="../assets/images/img13.jpg">
        <v-row align="end" class="lightbox white--text pa-2 fill-height">
          <v-col>
            <v-container>
              <div class="headline">About Us</div>
            </v-container>
          </v-col>
        </v-row>
      </v-img>
    </div>
    <div class="block">
      <v-container>
        <p>High-quality, fashionable cabinets constructed with the best materials are what we provide at JH-Y Kitchen Cabinets contract manufacturing. 
          We guarantee top-notch quality and client satisfaction because more than 80% of our supplies come from within the region. 
          Pick from our selection of cabinet sizes, which includes typical choices for most kitchens and customizable options for the ideal fit. 
          Standard cabinets are finished by our knowledgeable crew in 7–10 days. Our unwavering commitment to creating long-lasting cabinets is what distinguishes us. 
        </p>
        <p>Our family has been in the cabinet manufacturing industry since 2007, creating and distributing high-quality goods to Canadian consumers.
                    Our location is in Markham, Ontario. where we proudly manufacture all of our cabinets and doors here in
                    Ontario with cutting-edge equipment.
                    We provides classic design at a reasonable cost.
                    To guarantee that you are obtaining the perfect cabinet for your ideal space, all of our cabinets undergo stringent quality check.
                    Our pre-assembled cabinetry is particularly excellent for DIY projects, construction projects, and contractors. 144 Bullock Drive, Markham, Ontario, L3P 1W2, is where you may find our showroom. We invite you to come see us!</p>
        
      </v-container>
    </div>
  </v-content>
</template>

<script>
export default {
  name: "About",
  data() {
    return {
    };
  }
};
</script>